export const FACET_KEYS = [
  "empathy_erosion",
  "cynicism_envy",
  "entitlement_superiority",
  "manipulation_exploitation",
  "rigidity_intolerance",
  "blame_justification",
  "aggression_control",
  "moral_grandstanding",
] as const;
export type FacetKey = (typeof FACET_KEYS)[number];

export const DOMAIN_KEYS = [
  "warmth",
  "power",
  "cognition",
  "sanction",
] as const;
export type DomainKey = (typeof DOMAIN_KEYS)[number];

export type ScaleOption = Readonly<{ label: string; value: 1 | 2 | 3 | 4 | 5 }>;
export type ScenarioOption = Readonly<{
  id: string;
  label: string;
  score: 0 | 33 | 67 | 100;
}>;
export type Question = Readonly<{
  id: string;
  facet: FacetKey;
  kind: "current" | "change" | "scenario";
  prompt: string;
  reverse?: boolean;
  options: readonly (ScaleOption | ScenarioOption)[];
}>;

export type QuestionId =
  | "E1"
  | "E2"
  | "E3"
  | "C1"
  | "C2"
  | "C3"
  | "T1"
  | "T2"
  | "T3"
  | "M1"
  | "M2"
  | "M3"
  | "R1"
  | "R2"
  | "R3"
  | "B1"
  | "B2"
  | "B3"
  | "A1"
  | "A2"
  | "A3"
  | "G1"
  | "G2"
  | "G3";
export type AnswerValue = 1 | 2 | 3 | 4 | 5 | string;
export type AnswerMap = Partial<Record<QuestionId, AnswerValue>>;

export const TRIGGER_CODES = [
  "workload",
  "authority",
  "social_media",
  "life_change",
  "fatigue",
  "life_stage",
  "none",
] as const;
export type TriggerCode = (typeof TRIGGER_CODES)[number];
